import { Breadcrumbs } from "@/components";
import { configColor } from "@/utils";
import { useTranslation } from "react-i18next";
import { useIsMobile, useModule } from "../../hooks";

import Image from "next/image";
import DOMPurify from "isomorphic-dompurify";

interface INewsDetailsProps {
  data: any;
  language: string;
}

const NewsDetails: React.FC<INewsDetailsProps> = ({ data, language }) => {
  const { i18n } = useTranslation();
  const lang = language ? language : i18n.language;
  const [isMobile] = useIsMobile();

  const getCategory = () => {
    let categoryData: any = useModule(data?.xtaxNewsCategory?.ti[0].targeturl);
    return categoryData?.data?.lblNameCategory[lang];
  };

  const lblTitleNews = DOMPurify.sanitize(data?.lblTitleNews[lang]);
  const lblSubtitleNews = DOMPurify.sanitize(data?.lblSubtitleNews[lang]);
  const dteNews = data?.dteNews;

  const upiImageDesk =
    data?.lslParagraphs[0]?.upiImageDesktop[lang].mediaserverpath != undefined
      ? data?.lslParagraphs[0]?.upiImageDesktop[lang].mediaserverpath +
        "/" +
        data?.lslParagraphs[0]?.upiImageDesktop[lang].resourcename
      : "";
  const upiImageMob =
    data?.lslParagraphs[0]?.upiImageMobile[lang].mediaserverpath != undefined
      ? data?.lslParagraphs[0]?.upiImageMobile[lang].mediaserverpath +
        "/" +
        data?.lslParagraphs[0]?.upiImageMobile[lang].resourcename
      : "";

  return (
    <>
      <div className="max-w-cont-1 mx-auto w-full cont-news">
        <div className="pt-4">
          {!data?.flgHideNavigationéath ? <Breadcrumbs language={lang} /> : null}
        </div>

        <div className="p-EdgeMob tab:p-EdgeTab desk:p-EdgeDesk">
          <p className={`${configColor("text", "azzurro")} font-bold`}>{getCategory()}</p>

          <h1
            className="text-4xl py-3 font-semibold font-secondary"
            dangerouslySetInnerHTML={{ __html: lblTitleNews }}
          />
          <h2 className="py-2 font-semibold" dangerouslySetInnerHTML={{ __html: lblSubtitleNews }} />
          <p className="py-5">{dteNews}</p>

          {/* immagine header desktop */}
          {!isMobile && upiImageDesk && (
            <Image
              src={upiImageDesk}
              alt={`Immagine relativa alla notizia: ${data?.lblTitleNews?.[lang] || "notizia"}`}
              width={0}
              height={0}
              sizes="100vw"
              style={{ width: "100%", height: "auto" }}
              className="w-screen"
              unoptimized
              priority
            />
          )}

          {/* immagine header mobile */}
          {isMobile && upiImageMob && (
            <Image
              src={upiImageMob}
              alt={`Immagine relativa alla notizia: ${data?.lblTitleNews?.[lang] || "notizia"}`}
              width={0}
              height={0}
              sizes="100vw"
              style={{ width: "100%", height: "auto" }}
              className="w-screen"
              unoptimized
              priority
            />
          )}

          {data?.lslParagraphs.map((paragraph: any) => {
            const enuSubtitleColor = configColor("text", paragraph.enuSubtitleColor);
            const lblTitle = DOMPurify.sanitize(paragraph.lblTitle[lang]);
            const txbDescription = DOMPurify.sanitize(paragraph.txbDescription[lang]);

            return (
              <div key={paragraph.id} className={`${enuSubtitleColor}`}>
                <div className="pb-12 pt-8 underlineLink">
                  <h2 className={`text-xl font-bold text-red`} dangerouslySetInnerHTML={{ __html: lblTitle }} />
                  <h3 className={`py-5`} dangerouslySetInnerHTML={{ __html: txbDescription }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default NewsDetails;
